import { render, staticRenderFns } from "./SearchIANoResultComponent.vue?vue&type=template&id=5825de1e&scoped=true"
import script from "./SearchIANoResultComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchIANoResultComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchIANoResultComponent.vue?vue&type=style&index=0&id=5825de1e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5825de1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5825de1e')) {
      api.createRecord('5825de1e', component.options)
    } else {
      api.reload('5825de1e', component.options)
    }
    module.hot.accept("./SearchIANoResultComponent.vue?vue&type=template&id=5825de1e&scoped=true", function () {
      api.rerender('5825de1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documentSearcher/components/SearchAdvanceIA/components/SearchIANoResultComponent.vue"
export default component.exports